import { useMissionsTranslation } from '../../../../ui/hooks';
import { EmptyContentWrapper } from '@juvare/common-web-ui/EmptyContentWrapper';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React from 'react';
export const EmptyMissionList = ({ onCreateNewMission, allowMissionChange }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(EmptyContentWrapper, { description: t('missions.noMissions') }, allowMissionChange && onCreateNewMission && (React.createElement(Button, { startIcon: React.createElement(AddIcon, null), variant: 'contained', onClick: onCreateNewMission }, t('missions.addMission')))));
};
